import React, { Suspense } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import HomePage from './views/Home/Home';
import ThankyouPage from './views/Thankyou/Thankyou';
import Results from './views/Results/Results';

import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import { routes } from './config';

const Loading = () => {
  return (
    <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '100vh'}}>
      <LoadingScreen />
    </div>
  );
};

const App = () => {
	
  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Switch>
          <Route exact path={routes.home} component={HomePage} />
          <Route exact path={routes.thankyou} component={ThankyouPage} />
          <Route exact path={routes.results} component={Results} />

          <Route path={routes.refresh} component={(hist) => {
            const parts = hist.location.pathname.split('refresh');
            if (parts.length === 2 && parts[1] !== '') {
              hist.history.push(parts[1], hist.location.state);
            } else {
              hist.history.push('/');
            }
            return null;
          }}/>

          <Redirect to={routes.home} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
